import { Component, OnInit } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-edit-driver',
  templateUrl: './edit-driver.component.html',
  styleUrls: ['./edit-driver.component.css']
})
export class EditDriverComponent implements OnInit {
  editDriver: any = {
    driverName: "",
  };
  statusText2: string;
  statusText3: string;
  statusText4: string;
  statusText5: string;
  statusText6: string;
  statusText7: string;
  citiesList: any;
  addressTypes: any = [];
  addressType: string;
  addresses = [];
  statesList: any;

  constructor(private alertService: AlertService, private api: ApiIntegration, private g: Globals, public route: ActivatedRoute, public router: Router, private http: HttpClient) {
    this.g.page = "Edit Driver";
    this.stateList();
    this.cityList();
    this.api.getShiftDrivers(this.route.snapshot.params['id']).subscribe((data: any) => {
      this.editDriver = data;
      this.addresses = this.editDriver.addresses;
    },
      err => {
        this.alertService.error('Error', err);
      });
    this.api.getValues("1", "ADDRESS_TYPE", "ADDRESS_TYPE", "ADDRESS_TYPE").subscribe((data: any) => {
      this.addressTypes = data.tripleSetConfigDTOS;
    }, err => {
      console.log(err);
    });
  }

  stateList() {
    this.api.getDistinctStates().subscribe((data: any) => {
      this.statesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  cityList() {
    this.api.getDistinctCity().subscribe((data: any) => {
      this.citiesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  changeStateAndCity() {
    this.api.getCityAndStateByPinCode(this.addresses[0].zip).subscribe((data: any) => {
      this.addresses[0].city = data.city;
      this.addresses[0].state = data.state;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  ngOnInit() {
  }

  typeDriverName() {
    this.statusText2 = "";
    if (this.editDriver.driverName == '' || this.editDriver.driverName === null || this.editDriver.driverName === undefined || this.editDriver.driverName === 'undefined') {
      this.statusText2 = 'Please Enter driver name';
    }
  }

  typeAddress() {
    this.statusText4 = "";
    if (this.addresses[0].address1 == '' || this.addresses[0].address1 === null || this.addresses[0].address1 === undefined || this.addresses[0].address1 === 'undefined') {
      this.statusText4 = 'Please enter address 1';
    }
  }

  typeCity() {
    this.statusText5 = "";
    if (this.addresses[0].city == '' || this.addresses[0].city === null || this.addresses[0].city === undefined || this.addresses[0].city === 'undefined') {
      this.statusText5 = 'Please enter city';
    }
  }

  typeState() {
    this.statusText6 = "";
    if (this.addresses[0].state == '' || this.addresses[0].state === null || this.addresses[0].state === undefined || this.addresses[0].state === 'undefined') {
      this.statusText6 = 'Please enter state';
    }
  }

  typeZip() {
    this.statusText7 = "";
    if (this.addresses[0].zip == '' || this.addresses[0].zip === null || this.addresses[0].zip === undefined || this.addresses[0].zip === 'undefined') {
      this.statusText7 = 'Please enter zip';
    }
  }

  submitDriver() {
    this.g.loaderDisplay = "display";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    this.statusText6 = "";
    this.statusText7 = "";

    if (this.editDriver.driverName == '' || this.editDriver.driverName === null || this.editDriver.driverName === undefined || this.editDriver.driverName === 'undefined') {
      this.statusText2 = 'Please Enter driver name';
    }
    if (this.addresses[0].addressType == '' || this.addresses[0].addressType === null || this.addresses[0].addressType === undefined || this.addresses[0].addressType === 'undefined') {
      this.statusText3 = 'Please select addressType';
    }
    if (this.addresses[0].address1 == '' || this.addresses[0].address1 === null || this.addresses[0].address1 === undefined || this.addresses[0].address1 === 'undefined') {
      this.statusText4 = 'Please enter address 1';
    }
    if (this.addresses[0].city == '' || this.addresses[0].city === null || this.addresses[0].city === undefined || this.addresses[0].city === 'undefined') {
      this.statusText5 = 'Please enter city';
    }
    if (this.addresses[0].state == '' || this.addresses[0].state === null || this.addresses[0].state === undefined || this.addresses[0].state === 'undefined') {
      this.statusText6 = 'Please enter state';
    }
    if (this.addresses[0].zip == '' || this.addresses[0].zip === null || this.addresses[0].zip === undefined || this.addresses[0].zip === 'undefined') {
      this.statusText7 = 'Please enter zip';
    }
    if (this.statusText2 != "" || this.statusText3 != "" || this.statusText4 != "" || this.statusText5 != "" || this.statusText6 != "" || this.statusText7 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    //this.editDriver.addresses[0] = this.addresses;
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateDrivers', {
      "driverName": this.editDriver.driverName,
      "organizationId": 1,
      "id": this.route.snapshot.params['id'],
      "status": this.editDriver.status,
      "mobileNumber": this.editDriver.mobileNumber,
      "email": this.editDriver.email,
      "addresses": this.addresses,

    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Driver Details', 'Edited Successfully');

          this.router.navigate(['/admin/driversList']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        }
      )
  }
}
